module.exports = __webpack_public_path__ + "img/1530073748.6bdaef57.jpg";